import gql from 'graphql-tag';

import { clientWeb } from '../graphqlAPI';

const SET_SESSION_RESERVATION = gql`
  mutation Post($artistSetSlugName: String!) {
    setSessionReservation(artistSetSlugName: $artistSetSlugName ) {
      payed
      error {
        message
      }
    }
}`;

const setSessionReservation = async (formData) => {
  try {
    const result = await clientWeb.mutate({
      mutation: SET_SESSION_RESERVATION,
      variables: {
        ...formData,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { setSessionReservation: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: setSessionReservation Error: ${error}`);
    return null;
  }
};

export default setSessionReservation;
